<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">数据报告・学生使用报告</p>
				</div>
				<div class="student_report_screen">
					<div class="famous_screen_list flex mab10 mar20">
						<span class="cl_gray f18px">班级：</span>
						<el-select v-model="grade_cur" placeholder="全部" @change="gradeSelect">
							<el-option v-for="(item,index) in grade":key="index" :label="item.gradeName":value="item.gradeId"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list flex mab10 mar20">
						<el-select v-model="class_cur" placeholder="全部" @change="classSelect"  clearable>
							<el-option v-for="(item,index) in class_list":key="index" :label="item.name":value="item.id"></el-option>
						</el-select>
					</div>
					<div class="flex mab10 mar20 mal20">
						<span class="cl_gray f18px">周期：</span>
						<el-date-picker v-model="time_range" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 :picker-options="rangeTimeOption" class="student_report_range"></el-date-picker>
					</div>
					<button class="f16px cl_white student_report_screen_btn mab10 mal20" @click="submit">查询</button>
				</div>
				<div class="student_report flex cl_white">
					<div class="student_report_list mab30">
						<img src="../../../static/student_report_02.png" class="block" />
						<div class="student_report_list_div">
							<p class="f20px">看课次数</p>
							<p class="f36px mat10">{{data.course_view_num}}</p>
						</div>
					</div>
					<div class="student_report_list mab30">
						<img src="../../../static/student_report_01.png" class="block" />
						<div class="student_report_list_div">
							<p class="f20px">使用人数</p>
							<p class="f36px mat10">{{data.course_use_num}}</p>
						</div>
					</div>
					<div class="student_report_list mab30">
						<img src="../../../static/student_report_03.png" class="block" />
						<div class="student_report_list_div">
							<p class="f20px">答题数量</p>
							<p class="f36px mat10">{{data.question_record_num}}</p>
						</div>
					</div>
					<div class="student_report_list mab30">
						<img src="../../../static/student_report_04.png" class="block" />
						<div class="student_report_list_div">
							<p class="f20px">使用人数</p>
							<p class="f36px mat10">{{data.question_use_num}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 7,
					listCur: 3,
					open: 0,
				},
				grade: [], //年级
				grade_cur: "",
				class_list: [], //班级
				class_cur: "",
				start_time: "",
				end_time: "",
				time_range: "",
				rangeTimeOption: {
				  disabledDate: date => {
						return date.getTime() > Date.now();
				  }
				},
				data: {},
			}
		},
		created() {
			
		},
		mounted() {
			this.getGrade();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0].gradeId;
					this.getClass();
					this.getList();
				});
			},
			getClass () {
				this.$get("/api/teacher/get_class_list",{
					token: localStorage.getItem("token"),
					class_name: "",
					class_type: "",
					grade_id: this.grade_cur,
				})
				.then(res => {
					this.class_list = res.data;
				});
			},
			getList () {
				this.$get("/api/teacher/get_student_report_data",{
					token: localStorage.getItem("token"),
					grade_id: this.grade_cur,
					class_id: this.class_cur,
					start_time: this.start_time,
					end_time: this.end_time,
				})
				.then(res => {
					this.data = res.data;
				});
			},
			gradeSelect () {
				this.getClass();
			},
			classSelect () {
				
			},
			submit () {
				if (this.time_range == null || this.time_range == "") {
					this.time_range = "";
					this.start_time = "";
					this.end_time = "";
				} else {
					this.start_time = this.getTime(this.time_range[0]);
					this.end_time = this.getTime(this.time_range[1]);
				}
				this.getList();
			},
			getTime (time) {
				let t = "";
				let myDate = new Date(time);
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
		},
	}
</script>

<style>
</style>
